import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router'
import { BinesAbcComponent } from '../bines-abc/bines-abc.component';

declare var M: any;
@Component({
  selector: 'app-detalle-bin-prev',
  templateUrl: './detalle-bin-prev.component.html',
  styleUrls: ['./detalle-bin-prev.component.scss']
})

export class DetalleBinPrevComponent implements OnInit {
  @ViewChild(BinesAbcComponent) abc : BinesAbcComponent;
  instance: any;
  elems: any;
  private idBin:string;

  constructor(private _router: ActivatedRoute,
    private router: Router) {

  }

  cerrarProcesoCompleto() {
    this.elems = document.querySelectorAll('.modal');
    const instances = M.Modal.init(this.elems, Option);
    instances.close();
    instances.destroy();
  }

  ngOnInit() {
  }

  guardar() {
    if (this.abc.isInter) {
      this.abc.guardar();
    } else {
      let scope = this;
      scope.router.navigate(["/busquedaEjecutor"]);
    }
  }
  expandir() {
    this.abc.expandirCollapsables();
  }
}
